import React from 'react';

import Scale from './Scale';
import Note from './Note';
import WithScreen, { WithScreenProps } from '../ScreenBase';
import Rate from './Rate';
import Choice from './Choice';
import Input from './Input';
import ThankYou from './ThankYou';
import YesNo from './YesNo';
import Redirect from './Redirect';
import ScaleGroup from './ScaleGroup';

export default {
  Scale: WithScreen(Scale),
  Note: WithScreen(Note),
  Rate: WithScreen(Rate),
  Choice: WithScreen(Choice),
  Input: WithScreen(Input),
  ThankYou: WithScreen(ThankYou),
  YesNo: WithScreen(YesNo),
  Redirect: WithScreen(Redirect),
  ScaleGroup: WithScreen(ScaleGroup),
} as { [type: string]: React.ComponentType<WithScreenProps> };
